export default "__VITE_ASSET__95051f2e__"